import {
  Drawer,
  Toolbar,
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Box,
  IconButton,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import SummarizeTwoToneIcon from "@mui/icons-material/SummarizeTwoTone";
import CloseIcon from "@mui/icons-material/Close";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LockClockIcon from "@mui/icons-material/LockClock";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import PeopleIcon from "@mui/icons-material/People";
import BarChartIcon from "@mui/icons-material/BarChart";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ListAltIcon from "@mui/icons-material/ListAlt";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import SchoolIcon from "@mui/icons-material/School";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import PsychologyIcon from "@mui/icons-material/Psychology";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import FeaturedVideoIcon from "@mui/icons-material/FeaturedVideo";
import QuizIcon from "@mui/icons-material/Quiz";
import SavingsIcon from "@mui/icons-material/Savings";
import Person3Icon from "@mui/icons-material/Person3";
import NoteIcon from "@mui/icons-material/Note";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import PaidIcon from "@mui/icons-material/Paid";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import AdUnitsIcon from "@mui/icons-material/AdUnits";
import { PropsWithoutRef } from "react";
import { SIDEBAR_WIDTH } from "../helpers/constants/SideBarWidth";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import Settings from "@mui/icons-material/Settings";
import DuoIcon from "@mui/icons-material/Duo";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import SubjectIcon from "@mui/icons-material/Subject";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import QrCodeIcon from "@mui/icons-material/QrCode";
import ForumIcon from "@mui/icons-material/Forum";
import PostAddIcon from "@mui/icons-material/PostAdd";
import FlagCircleIcon from "@mui/icons-material/FlagCircle";
import ClassIcon from "@mui/icons-material/Class";
interface Props {
  mobileOpen: boolean;
  handleSidebarToggle: () => void;
}

export default function Sidebar({
  mobileOpen,
  handleSidebarToggle,
}: PropsWithoutRef<Props>) {
  const location = useLocation();
  const navigate = useNavigate();

  const drawer = (
    <>
      <Toolbar className="sidebar-logo" sx={{ position: "relative" }}>
        <figure
          className="logo_cntnr"
          style={{
            backgroundColor: "white",
            marginBottom: 10,
            padding: 6,
            borderRadius: "6px",
          }}
        >
          <img src="/static/images/logo.png" alt="" />
        </figure>
        <IconButton
          sx={{
            position: "absolute",
            top: "10px",
            right: "10px",
            color: "white",
            display: { lg: "none" },
          }}
          onClick={handleSidebarToggle}
        >
          <CloseIcon />
        </IconButton>
      </Toolbar>

      <List sx={{ flexGrow: 1 }} className="sidebr-lst">
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/dashboard"}
          onClick={() => navigate("/dashboard")}
        >
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Dashboard" />
        </ListItemButton>
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manageUsers" ||
            location.pathname === "/manageusers" ||
            location.pathname.startsWith("/manageusers/userdetails/") ||
            location.pathname.startsWith("/manageusers/usersform/")
          }
          onClick={() => navigate("/manageusers")}
        >
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Users" />
        </ListItemButton>

        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-tutors" ||
            location.pathname.startsWith("/manage-tutors/details") ||
            location.pathname.startsWith("/manage-tutors/edit") ||
            location.pathname.startsWith("/manage-tutor/add") ||
            location?.pathname.startsWith(
              "/manage-tutor/details/NextTutorDetail"
            )
          }
          onClick={() => navigate("/manage-tutors")}
        >
          <ListItemIcon>
            <Person3Icon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Tutors" />
        </ListItemButton>

        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-bookings"
            // location.pathname.startsWith("/manage-bookings/details")
          }
          onClick={() => navigate("/manage-bookings")}
        >
          <ListItemIcon>
            <NoteIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Bookings" />
        </ListItemButton>

        {/* <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/online-booking"}
          onClick={() => navigate("/online-booking")}
        >
          <ListItemIcon>
            <BookOnlineIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary="Manage Online Bookings"
          />
        </ListItemButton> */}
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/class-booking"}
          onClick={() => navigate("/class-booking")}
        >
          <ListItemIcon>
            <ClassIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary="Manage Class Bookings"
          />
        </ListItemButton>
        {/* category-subject */}
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-subject-category" ||
            location.pathname.startsWith("/manage-subject-category/details") ||
            location.pathname.startsWith("/manage-subject-category/edit") ||
            location.pathname.startsWith("/manage-subject-category/add")
            // location?.pathname.startsWith(
            //   "/manage-tutor/details/NextTutorDetail"
            // )
          }
          onClick={() => navigate("/manage-subject-category")}
        >
          <ListItemIcon>
            <SubjectIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary="Manage Subject Category"
          />
        </ListItemButton>
        {/* classes */}
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-classes" ||
            location.pathname.startsWith("/manage-classes/details") ||
            location.pathname.startsWith("/manage-classes/edit") ||
            location.pathname.startsWith("/manage-classes/add")
            // location?.pathname.startsWith(
            //   "/manage-tutor/details/NextTutorDetail"
            // )
          }
          onClick={() => navigate("/manage-classes")}
        >
          <ListItemIcon>
            <SchoolIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Classes" />
        </ListItemButton>
        {/* /manage-banner */}
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-banner" ||
            location.pathname.startsWith("/manage-banner/details") ||
            location.pathname.startsWith("/manage-banner/edit") ||
            location.pathname.startsWith("/manage-banner/add")
          }
          onClick={() => navigate("/manage-banner")}
        >
          <ListItemIcon>
            <AdUnitsIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Banner" />
        </ListItemButton>
        {/* /manage-forum */}
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-forum" ||
            location.pathname.startsWith("/manage-forum/details") ||
            location.pathname.startsWith("/manage-forum/edit") ||
            location.pathname.startsWith("/manage-forum/add")
            // location?.pathname.startsWith(
            //   "/manage-tutor/details/NextTutorDetail"
            // )
          }
          onClick={() => navigate("/manage-forum")}
        >
          <ListItemIcon>
            <ForumIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Forum" />
        </ListItemButton>
        {/* /manage-post */}
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-post" ||
            location.pathname.startsWith("/manage-post/details") ||
            location.pathname.startsWith("/manage-post/edit") ||
            location.pathname.startsWith("/manage-post/add")
            // location?.pathname.startsWith(
            //   "/manage-tutor/details/NextTutorDetail"
            // )
          }
          onClick={() => navigate("/manage-post")}
        >
          <ListItemIcon>
            <PostAddIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Posts" />
        </ListItemButton>
        {/* videos */}
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-short-video" ||
            location.pathname.startsWith("/manage-short-video/details") ||
            location.pathname.startsWith("/manage-short-video/edit")
            // location.pathname.startsWith("/manage-short-video/add") ||
            // location?.pathname.startsWith(
            //   "/manage-tutor/details/NextTutorDetail"
            // )
          }
          onClick={() => navigate("/manage-short-video")}
        >
          <ListItemIcon>
            <DuoIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Short Videos" />
        </ListItemButton>
        {/* videos */}
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-videos" ||
            location.pathname.startsWith("/manage-videos/details") ||
            location.pathname.startsWith("/manage-videos/edit")
            // location.pathname.startsWith("/manage-short-video/add") ||
            // location?.pathname.startsWith(
            //   "/manage-tutor/details/NextTutorDetail"
            // )
          }
          onClick={() => navigate("/manage-videos")}
        >
          <ListItemIcon>
            <OndemandVideoIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Teasor Videos" />
        </ListItemButton>
        {/* promocodes */}
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/manage-promocodes"}
          onClick={() => navigate("/manage-promocodes")}
        >
          <ListItemIcon>
            <QrCodeIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Promocodes" />
        </ListItemButton>
        {/* payment request */}
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/paymentRequest" ||
            location.pathname.startsWith("/paymentRequestDetails")
          }
          onClick={() => navigate("/paymentRequest")}
        >
          <ListItemIcon>
            <AttachMoneyIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Payment Request" />
        </ListItemButton>
        {/* refund request */}
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/refundRequest" ||
            location.pathname.startsWith("/refundRequestDetails")
          }
          onClick={() => navigate("/refundRequest")}
        >
          <ListItemIcon>
            <KeyboardReturnIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Refund" />
        </ListItemButton>
        {/* refund request */}
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/payment" ||
            location.pathname.startsWith("/paymentDetails")
          }
          onClick={() => navigate("/payment")}
        >
          <ListItemIcon>
            <AttachMoneyIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Payment" />
        </ListItemButton>

        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/manage-short-video-reports"}
          onClick={() => navigate("/manage-short-video-reports")}
        >
          <ListItemIcon>
            <ReportProblemIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Reported Content" />
        </ListItemButton>
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/manage-reported"}
          onClick={() => navigate("/manage-reported")}
        >
          <ListItemIcon>
            <FlagCircleIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Reported Tutors" />
        </ListItemButton>

        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/customer-support"}
          onClick={() => navigate("/customer-support")}
        >
          <ListItemIcon>
            <HelpCenterIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Customer Support" />
        </ListItemButton>
        {/* inquiries */}
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/manage-inquiries"}
          onClick={() => navigate("/manage-inquiries")}
        >
          <ListItemIcon>
            <InfoOutlinedIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Inquiries" />
        </ListItemButton>

        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-reviews" ||
            location.pathname.startsWith("/manage-reviews/details")
          }
          onClick={() => navigate("/manage-reviews")}
        >
          <ListItemIcon>
            <ThumbUpIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Reviews" />
        </ListItemButton>

        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-notifications" ||
            location.pathname === "/recieved-notifications" ||
            location.pathname === "/manage-notifications/add"
          }
          onClick={() => navigate("/manage-notifications")}
        >
          <ListItemIcon>
            <NotificationsActiveIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Notifications" />
        </ListItemButton>
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/analytics"}
          onClick={() => navigate("/analytics")}
        >
          <ListItemIcon>
            <BarChartIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary="Reports and Analytics"
          />
        </ListItemButton>
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/cms"}
          onClick={() => navigate("/cms")}
        >
          <ListItemIcon>
            <SummarizeTwoToneIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage CMS" />
        </ListItemButton>
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/faq"}
          onClick={() => navigate("/faq")}
        >
          <ListItemIcon>
            <QuizIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary=" Manage FAQs" />
        </ListItemButton>
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/manage-settings"}
          onClick={() => navigate("/manage-settings")}
        >
          <ListItemIcon>
            <Settings />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Settings" />
        </ListItemButton>
      </List>
    </>
  );

  return (
    <Box
      component="nav"
      sx={{ flexShrink: { lg: 0 } }}
      className="sidebar-main-div"
    >
      <Drawer
        className="sidebar_drawer"
        variant="temporary"
        open={mobileOpen}
        onClose={handleSidebarToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block", lg: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: SIDEBAR_WIDTH,
          },
        }}
      >
        {drawer}
      </Drawer>
      <Drawer
        variant="permanent"
        className="sidebar_drawer"
        sx={{
          display: { xs: "none", lg: "block" },
          "& .MuiDrawer-paper": {
            width: SIDEBAR_WIDTH,
            boxSizing: "border-box",
          },
        }}
        open
      >
        {drawer}
      </Drawer>
    </Box>
  );
}
